import { IData } from '../fetchEndPrice'
import { IEndPrice } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): IEndPrice => ({
      endPrice: Number(item.price).toFixed(2),
      localTaxIncluded: Number(item.local_tax_included).toFixed(2),
      provision: Number(item.provision).toFixed(2),
      tax: Number(item.local_tax).toFixed(2),
    }),
  )
}
